module.exports = __webpack_public_path__ + "media/images/bus/conditions/REFU-03105369e58fc49580771b466e71fcb8.svg";